import { getString } from "../../common/common";

export const TAB2_HEADING1 = "TAB2_HEADING1";
export const TAB2_HEADING2 = "TAB2_HEADING2";

export const TAB2_LI1 = "TAB2_LI1";
export const TAB2_LI2 = "TAB2_LI2";
export const TAB2_LI3 = "TAB2_LI3";
export const TAB2_LI4 = "TAB2_LI4";
export const TAB2_LI5 = "TAB2_LI5";
export const TAB2_LI6 = "TAB2_LI6";
export const TAB2_LI7 = "TAB2_LI7";
export const TAB2_LI8 = "TAB2_LI8";
export const TAB2_LI9 = "TAB2_LI9";
export const TAB2_LI10 = "TAB2_LI10";

export const translations = {
  en: {
    [TAB2_HEADING1]: "Airavat Club Class",
    [TAB2_HEADING2]:
      "The silent features of Airavat Club Class are as follows:",

    [TAB2_LI1]:
      "The 13.8 mtr length fully built bus developed exclusively for passenger transport. The said buses are provided with multi axle which enhances the comfort level for long distance travel.",
    [TAB2_LI2]:
      "Full air suspension, fitted with two air bellows in the front and six air bellows in the rear to offer a high degree of ride comfort.",
    [TAB2_LI3]:
      'This bus is provided with good branded "carrier" make air-conditioner with excellent cooling effect to make the journey comfortable & cool.',
    [TAB2_LI4]:
      "This bus is provided with 53 nos. ergonomically designed executive, comfortable, reclining luxurious passenger seats.",
    [TAB2_LI5]:
      'The passenger saloon is provided with ultra modern interiors, reclining hi-tech passenger seats, imported floor carpeting, high mounted 2 LCD TVs of 26" & 17" to have better viewing pleasure for passengers.',
    [TAB2_LI6]:
      "Emergency door is provided on right hand side of the bus for more safety to passengers.",
    [TAB2_LI7]:
      "The window glasses are toughened and provide clear vision to the passengers.",
    [TAB2_LI8]:
      "Front panel is designed to increase the driver`s vision area and aesthetic look of the bus.",
    [TAB2_LI9]:
      "10 Cu mtr luggage space is provided under passenger seating area.",
    [TAB2_LI10]:
      "The bus is fitted with 340 Horse power, powerful, fuel – efficient and electronically controlled Volvo D9B engine with a turbocharger and intercooler, Euro III compliant.",
  },
  kn: {
    [TAB2_HEADING1]: "ಐರಾವತ್ ಕ್ಲಬ್ ಕ್ಲಾಸ್",
    [TAB2_HEADING2]: "ಐರಾವತ್ ಕ್ಲಬ್ ಕ್ಲಾಸ್‌ನ ವಿಶೇಷ  ವೈಶಿಷ್ಟ್ಯಗಳು ಈ ಕೆಳಗಿನಂತಿವೆ:",
    [TAB2_LI1]:
      "13.8 ಮೀ  ಉದ್ದದ ಸಂಪೂರ್ಣವಾಗಿ ನಿರ್ಮಿಸಲಾದ ಬಸ್ ಪ್ರಯಾಣಿಕರ ಸಾರಿಗೆಗಾಗಿ ಪ್ರತ್ಯೇಕವಾಗಿ ಅಭಿವೃದ್ಧಿಪಡಿಸಲಾಗಿದೆ. ಈ  ಬಸ್‌ಗಳಿಗೆ ಮಲ್ಟಿ ಆಕ್ಸಲ್ ಅನ್ನು ನೀಡಲಾಗಿದ್ದು, ಇದು ದೂರದ ಪ್ರಯಾಣಕ್ಕಾಗಿ ಹೆಚ್ಚಿನ ಸೌಕರ್ಯವನ್ನು ನೀಡುತ್ತದೆ.",
    [TAB2_LI2]:
      "ಪೂರ್ಣ ಏರ್ ಸಸ್ಪೆನ್ಷನ್, ಮುಂಭಾಗದಲ್ಲಿ ಎರಡು ಏರ್ ಬೆಲ್ಲೋಗಳನ್ನು ಮತ್ತು ಹಿಂಭಾಗದಲ್ಲಿ ಆರು ಏರ್ ಬೆಲ್ಲೋಗಳನ್ನು ಅಳವಡಿಸಲಾಗಿದ್ದು, ಹೆಚ್ಚಿನ ಮಟ್ಟದ ಸವಾರಿ ಸೌಕರ್ಯವನ್ನು ನೀಡುತ್ತದೆ.",
    [TAB2_LI3]:
      'ಈ ಬಸ್ಸಿನಲ್ಲಿ ಉತ್ತಮ ಬ್ರಾಂಡ್ "ಕ್ಯಾರಿಯರ್" ಹವಾನಿಯಂತ್ರಣ ನೀಡಲಾಗಿದ್ದು ಇದು ಪ್ರಯಾಣವನ್ನು ಆರಾಮದಾಯಕ ಮತ್ತು ತಂಪಾಗಿ ಗಿಸುತ್ತದೆ, .',
    [TAB2_LI4]:
      "ಈ ಬಸ್ ನಲ್ಲಿ 53  ಸಂಖ್ಯೆಗಳಿದ್ದು. ದಕ್ಷತಾಶಾಸ್ತ್ರದ ವಿನ್ಯಾಸದಲ್ಲಿ ಎಕ್ಸಿಕ್ಯೂಟಿವ್, ಆರಾಮದಾಯಕ, ಒರಗಿಕೊಳ್ಳುವ ಐಷಾರಾಮಿ ಪ್ರಯಾಣಿಕರ ಸೀಟುಗಳು ಇವೆ.",
    [TAB2_LI5]:
      'ಪ್ಯಾಸೆಂಜರ್ ಕೊಠಡಿಯಲ್ಲಿ ಅಲ್ಟ್ರಾ ಮಾಡರ್ನ್ ಇಂಟೀರಿಯರ್‌ಗಳು, ಒರಗಿರುವ ಹೈಟೆಕ್ ಪ್ಯಾಸೆಂಜರ್ ಸೀಟ್‌ಗಳು, ಆಮದು ಮಾಡಿದ ನೆಲದ ಕಾರ್ಪೆಟಿಂಗ್, 26" & 17" ನ ಎತ್ತರದ 2 LCD ಟಿವಿಗಳು ಪ್ರಯಾಣಿಕರಿಗೆ ಒಳ್ಳೆಯ ನೋಡುವ ಆನಂದವನ್ನು ಒದಗಿಸಲಾಗಿದೆ.',
    [TAB2_LI6]:
      "ಪ್ರಯಾಣಿಕರಿಗೆ ಹೆಚ್ಚಿನ ಸುರಕ್ಷತೆಗಾಗಿ ಬಸ್ಸಿನ ಬಲಭಾಗದಲ್ಲಿ ತುರ್ತು ಬಾಗಿಲನ್ನು ಒದಗಿಸಲಾಗಿದೆ.",
    [TAB2_LI7]:
      "ಕಿಟಕಿಯ ಗ್ಲಾಸ್‌ಗಳನ್ನು ಗಟ್ಟಿಗೊಳಿಸಲಾಗಿದೆ ಮತ್ತು ಪ್ರಯಾಣಿಕರಿಗೆ ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣಿಸುತ್ತದೆ .",
    [TAB2_LI8]:
      "ಚಾಲಕನ ದೃಷ್ಟಿ ಚೆನ್ನಾಗಿ ಕಾಣಲು  ಮತ್ತು ಬಸ್‌ನ ಸೌಂದರ್ಯದ ನೋಟವನ್ನು ಹೆಚ್ಚಿಸಲು ಮುಂಭಾಗದ ಫಲಕವನ್ನು ವಿನ್ಯಾಸ ಮಾಡಲಾಗಿದೆ .",
    [TAB2_LI9]:
      "ಪ್ರಯಾಣಿಕರ ಸೀಟಿನ ಜಾಗದಲ್ಲಿ ಅಡಿಯಲ್ಲಿ 10 Cu mtr ಲಗೇಜ್ ಜಾಗವನ್ನು ನೀಡಲಾಗಿದೆ",
    [TAB2_LI10]:
      "ಬಸ್‌ನಲ್ಲಿ 340 ಹಾರ್ಸ್ ಪವರ್, ಶಕ್ತಿಶಾಲಿ, ಇಂಧನ - ಸಮರ್ಥ ಮತ್ತು ಎಲೆಕ್ಟ್ರಾನಿಕ್ ನಿಯಂತ್ರಿತ ವೋಲ್ವೋ D9B ಎಂಜಿನ್ ಅನ್ನು ಟರ್ಬೋಚಾರ್ಜರ್ ಮತ್ತು ಇಂಟರ್‌ಕೂಲರ್, ಯುರೋ III ಕಂಪ್ಲೈಂಟ್‌ನೊಂದಿಗೆ ಅಳವಡಿಸಲಾಗಿದೆ.",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
